// lib/tracking/meta-events.ts

export const pageview = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    (window as any).fbq('track', 'PageView');
  }
};

// https://developers.facebook.com/docs/meta-pixel/reference#standard-events
export const trackViewContent = (product: { id: string; name: string; price: number; currency?: string }) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    (window as any).fbq('track', 'ViewContent', {
      content_name: product.name,
      content_category: 'product',
      content_ids: [product.id], // Exactly matches the item.id in the XML feed
      content_type: 'product',
      value: product.price,
      currency: product.currency || 'USD',
    });
  }
};

export const trackAddToCart = (product: { id: string; name: string; price: number; quantity: number; currency?: string }) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    (window as any).fbq('track', 'AddToCart', {
      content_name: product.name,
      content_ids: [product.id], // Exactly matches the item.id in the XML feed
      content_type: 'product',
      value: product.price * product.quantity,
      currency: product.currency || 'USD',
      num_items: product.quantity,
    });
  }
};

export const trackPurchase = (orderId: string, value: number, currency: string = 'USD', items: { id: string; quantity: number }[]) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    (window as any).fbq('track', 'Purchase', {
      content_ids: items.map(item => item.id), // Exact matches
      content_type: 'product',
      value: value,
      currency: currency,
      num_items: items.reduce((sum, item) => sum + item.quantity, 0),
      order_id: orderId, // Used by Facebook for deduplication
    });
  }
};
